export default __webpack_public_path__ + "static/media/learose3-480w.9c4b8c14.png";